export default __webpack_public_path__ + "static/media/print.d931186a.svg";